/**
 * Initialize form flow engine. This is a one time setup and the configuration will be persisted until disposed using {@link disposeFormFlowEngine}.
 * @param options Form Flow engine options for running form flows.
 */
export function initializeFormFlowEngine(options) {
    globalThis.formFlowEngineOptions = options;
}
/** Clears the form flow engine options. Any subsequent form flow invocations will throw error. */
export function disposeFormFlowEngine() {
    delete globalThis.formFlowEngineOptions;
}
export function getFormFlowDefinitionLoader() {
    const formFlowEngineOptions = getFormFlowEngineOptions();
    if (!(formFlowEngineOptions === null || formFlowEngineOptions === void 0 ? void 0 : formFlowEngineOptions.definitionLoader)) {
        throw new Error('[Form Flow Engine] Form flow engine is not initialized. Initialize the form flow engine and provide a "definitionLoader" to enable support for form flows.');
    }
    return formFlowEngineOptions.definitionLoader;
}
export function getActivityBasedFormFlowFactory() {
    const formFlowEngineOptions = getFormFlowEngineOptions();
    if (!(formFlowEngineOptions === null || formFlowEngineOptions === void 0 ? void 0 : formFlowEngineOptions.activityBasedFormFlowFactory)) {
        throw new Error('[Form Flow Engine] Activity based form flows are not supported. Initialize the form flow engine by providing a "activityBasedFormFlowFactory".');
    }
    return formFlowEngineOptions.activityBasedFormFlowFactory;
}
export function isStrictParameterCheckingEnabled() {
    const formFlowEngineOptions = getFormFlowEngineOptions();
    if (!(formFlowEngineOptions === null || formFlowEngineOptions === void 0 ? void 0 : formFlowEngineOptions.definitionLoader)) {
        throw new Error("[Form Flow Engine] Form flow engine is not initialized.");
    }
    return formFlowEngineOptions.disableStrictParameterTypeChecking !== true;
}
function getFormFlowEngineOptions() {
    return globalThis.formFlowEngineOptions;
}
